module.exports = __webpack_public_path__ + "static/media/library.c5d5a152.svg";